import React from "react";
import AuthenticatedApp from "./AuthenticatedApp";
import UnauthenticatedApp from "./UnauthenticatedApp";
import { usePartialState } from "../../hooks/usePartialState";
import AppLoading from "../shared/AppLoading";
import store from "../../store";
import { BrowserRouter } from "react-router-dom";
import useRoutePrefix from "../../hooks/useRoutePrefix";
const App = () => {
    const { isLoggedIn, isAppLoading } = usePartialState(store.auth, ["isLoggedIn", "isAppLoading"]);
    const { getByAuthentication } = useRoutePrefix();
    if (isAppLoading)
        return <AppLoading />;
    return (<BrowserRouter basename={getByAuthentication()}>
      {isLoggedIn ? (<AuthenticatedApp />) : (<UnauthenticatedApp />)}
    </BrowserRouter>);
};
export default App;
